import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { patientFileuploader } from "../network/Network";
import { backimg, file } from "../Constant/Index";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

function Fileuploader({ toke }) {
	const navigate = useNavigate();
	const [selectedFiles, setSelectedFiles] = useState([]);
	const token = useSelector((state) => state?.Auth?.token);
	let currentUrl = window.location.href.split("/");
	const [loading, setLoading] = useState(false);

	// Handle file input change
	const handleFileChange = (e) => {
		const files = Array.from(e.target.files);
		setSelectedFiles([...selectedFiles, ...files]);
	};

	// Handle file removal
	const handleRemoveFile = (index) => {
		const newFilesArray = selectedFiles.filter((_, i) => i !== index);
		setSelectedFiles(newFilesArray);

		// Clear the input field
		document.getElementById("file-input").value = "";
	};

	// File Uploader Function
	// const fileUploader = (e) => {
	// 	e.preventDefault();
	// 	setLoading(true);

	// 	if (!selectedFiles) {
	// 		Swal.fire({
	// 			position: "center",
	// 			icon: "error",
	// 			text: "Kindly upload Report",
	// 			showConfirmButton: false,
	// 			timer: 1500,
	// 		});
	// 	}
	// 	let data = {
	// 		reports: selectedFiles,
	// 	};

	// 	patientFileuploader(data, toke ? toke : token)
	// 		.then((res) => {
	// 			Swal.fire({
	// 				position: "center",
	// 				icon: "success",
	// 				text: "Medical Reports has been uploaded successfully",
	// 				showConfirmButton: false,
	// 				timer: 1500,
	// 			});
	// 			if (toke) {
	// 				navigate("/sign-in");
	// 			} else {
	// 				navigate("/upload-medical-reports");
	// 			}
	// 			setSelectedFiles([]);
	// 			setLoading(false);
	// 		})
	// 		.catch((err) => {
	// 			Swal.fire({
	// 				position: "center",
	// 				icon: "error",
	// 				text: err?.response?.data?.errors?.reports[0],
	// 				showConfirmButton: false,
	// 				timer: 1500,
	// 			});
	// 			setLoading(false);
	// 		});
	// };

	const fileUploader = (e) => {
		e.preventDefault();
		setLoading(true);

		if (!selectedFiles || selectedFiles.length === 0) {
			Swal.fire({
				position: "center",
				icon: "error",
				text: "Kindly upload report",
				showConfirmButton: false,
				timer: 1500,
			});
			setLoading(false); // stop loader
			return; // exit early if no file
		}

		const data = {
			reports: selectedFiles,
		};

		patientFileuploader(data, toke || token)
			.then((res) => {
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Medical reports have been uploaded successfully",
					showConfirmButton: false,
					timer: 1500,
				});
				setSelectedFiles([]);
				setLoading(false);

				if (toke) {
					navigate("/sign-in");
				} else {
					navigate("/upload-medical-reports");
				}
			})
			.catch((err) => {
				const errorMsg =
					err?.response?.data?.errors?.reports?.[0] || "Something went wrong";
				Swal.fire({
					position: "center",
					icon: "error",
					text: errorMsg,
					showConfirmButton: false,
					timer: 1500,
				});
				setLoading(false);
			});
	};

	// =========================
	return (
		<section className="file_upload_sec">
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="main-profile-content radius-20 p-4">
							<div className="row input-file-wrapper">
								<div className="form-group col-lg-12">
									<div className="file_uploader_dv">
										<span
											style={{
												width: "100%",
												height: "50px",
												lineHeight: "47px",
												cursor: "pointer",
											}}
											className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none "
										>
											Upload Your File
										</span>
										<input
											className="form-group d-flex-wrapper-upload col-lg-12"
											id="file-input"
											type="file"
											onChange={handleFileChange}
											multiple
											style={{
												width: "100%",
												opacity: "1",
												position: "relative",
												opacity: "0",
											}}
										/>
									</div>
								</div>

								{selectedFiles.length > 0 ? (
									<>
										<ul className="mt-3">
											{selectedFiles?.map((file, index) => (
												<li
													className="form-group d-flex-wrapper-upload col-lg-12 m-2"
													key={index}
												>
													<div className="pdf-icon">
														<i className="fa-solid fa-file-pdf"></i>
													</div>
													{file.name}
													<div className="close_tag">
														<i
															style={{
																cursor: "pointer",
															}}
															onClick={() => handleRemoveFile(index)}
															className="fa-solid fa-xmark"
														></i>
													</div>
												</li>
											))}
										</ul>
									</>
								) : (
									<>
										<div
											className={
												currentUrl[3] == "medical-report"
													? "back_img_dv2"
													: "back_img_dv"
											}
										>
											<img src={backimg} />
										</div>
									</>
								)}
								<Link
									className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none w-100"
									to=""
								>
									<span
										onClick={(e) => fileUploader(e)}
										className="loading-btn loading bg-wrapper w-100"
									>
										<span className="pe-2">
											<i className="fa-solid fa-upload"></i>
										</span>
										{loading ? (
											<i className="fa fa-spinner"></i>
										) : (
											"Submit Report"
										)}
									</span>
								</Link>
								{currentUrl[3] == "user-signup-detail" ? (
									<div className="skip_dv">
										<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
											{toke ? (
												<Link
													to="/sign-in"
													className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
												>
													Skip
												</Link>
											) : (
												<Link
													to="/personal-info"
													className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
												>
													Skip
												</Link>
											)}
										</h4>
									</div>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Fileuploader;
